import {JsonProperty} from '../shared/decorators/json-property';

export class WalletReportInfo {
  @JsonProperty('deposit_by_btc')
  depositByBTC: number;
  @JsonProperty('deposit_by_eth')
  depositByETH: number;
  @JsonProperty('deposit_by_xrp')
  depositByXRP: number;
  @JsonProperty('deposit_by_usd')
  depositByUSD: number;
  @JsonProperty('deposit_by_jpy')
  depositByJPY: number;
  @JsonProperty('deposit_by_usdt')
  depositByUSDT: number;
  @JsonProperty('deposit_in_btc')
  depositInBTC: number;
  @JsonProperty('deposit_in_eth')
  depositInETH: number;
  @JsonProperty('deposit_in_xrp')
  depositInXRP: number;
  @JsonProperty('deposit_in_usd')
  depositInUSD: number;
  @JsonProperty('deposit_in_jpy')
  depositInJPY: number;
  @JsonProperty('deposit_in_usdt')
  depositInUSDT: number;
  @JsonProperty('nav_by_btc')
  navByBTC: number;
  @JsonProperty('nav_by_eth')
  navByETH: number;
  @JsonProperty('nav_by_xrp')
  navByXRP: number;
  @JsonProperty('nav_by_usd')
  navByUSD: number;
  @JsonProperty('nav_by_jpy')
  navByJPY: number;
  @JsonProperty('nav_by_usdt')
  navByUSDT: number;
  @JsonProperty('nav_in_btc')
  navInBTC: number;
  @JsonProperty('nav_in_eth')
  navInETH: number;
  @JsonProperty('nav_in_xrp')
  navInXRP: number;
  @JsonProperty('nav_in_usd')
  navInUSD: number;
  @JsonProperty('nav_in_jpy')
  navInJPY: number;
  @JsonProperty('nav_in_usdt')
  navInUSDT: number;
  @JsonProperty('withdraw_by_btc')
  withdrawByBTC: number;
  @JsonProperty('withdraw_by_eth')
  withdrawByETH: number;
  @JsonProperty('withdraw_by_xrp')
  withdrawByXRP: number;
  @JsonProperty('withdraw_by_usd')
  withdrawByUSD: number;
  @JsonProperty('withdraw_by_jpy')
  withdrawByJPY: number;
  @JsonProperty('withdraw_by_usdt')
  withdrawByUSDT: number;
  @JsonProperty('withdraw_in_btc')
  withdrawInBTC: number;
  @JsonProperty('withdraw_in_eth')
  withdrawInETH: number;
  @JsonProperty('withdraw_in_xrp')
  withdrawInXRP: number;
  @JsonProperty('withdraw_in_usd')
  withdrawInUSD: number;
  @JsonProperty('withdraw_in_jpy')
  withdrawInJPY: number;
  @JsonProperty('withdraw_in_usdt')
  withdrawInUSDT: number;
  constructor() {
    this.depositByBTC = undefined;
    this.depositByETH = undefined;
    this.depositByXRP = undefined;
    this.depositByUSD = undefined;
    this.depositByJPY = undefined;
    this.depositByUSDT = undefined;
    this.depositInBTC = undefined;
    this.depositInETH = undefined;
    this.depositInXRP = undefined;
    this.depositInUSD = undefined;
    this.depositInJPY = undefined;
    this.depositInUSDT = undefined;
    this.navByBTC = undefined;
    this.navByETH = undefined;
    this.navByXRP = undefined;
    this.navByUSD = undefined;
    this.navByJPY = undefined;
    this.navByUSDT = undefined;
    this.navInBTC = undefined;
    this.navInETH = undefined;
    this.navInXRP = undefined;
    this.navInUSD = undefined;
    this.navInJPY = undefined;
    this.navInUSDT = undefined;
    this.withdrawByBTC = undefined;
    this.withdrawByETH = undefined;
    this.withdrawByXRP = undefined;
    this.withdrawByUSD = undefined;
    this.withdrawByJPY = undefined;
    this.withdrawByUSDT = undefined;
    this.withdrawInBTC = undefined;
    this.withdrawInETH = undefined;
    this.withdrawInXRP = undefined;
    this.withdrawInUSD = undefined;
    this.withdrawInJPY = undefined;
    this.withdrawInUSDT = undefined;
  }
}

export class WalletReport {
  @JsonProperty({ clazz: WalletReportInfo, name: 'exchange' })
  exchange: WalletReportInfo;
  @JsonProperty({ clazz: WalletReportInfo, name: 'customer' })
  customer: WalletReportInfo;
  @JsonProperty({ clazz: WalletReportInfo, name: 'founder' })
  founder: WalletReportInfo;
  constructor() {
    this.exchange = new WalletReportInfo();
    this.customer = new WalletReportInfo();
    this.founder = new WalletReportInfo();
  }
}
